import styled from "styled-components";

const Container = styled.div.attrs({
  className: "w-full flex flex-col items-center max-w-md px-6 mx-auto",
})``;

const Icon = styled.div.attrs({
  className: "w-full flex flex-col items-center mb-5",
})``;

const Title = styled.div.attrs({
  className: "text-center text-lav-black text-xl font-bold mb-5",
})``;

const Subtitle = styled.div.attrs({
  className: "text-center text-lav-black",
})``;

const ButtonsContainer = styled.div.attrs({
  className: "w-full flex mt-10 mb-2",
})``;

const styles = {
  Container,
  Icon,
  Title,
  Subtitle,
  ButtonsContainer,
};

export default styles;
